import { useEffect, useState } from 'react';

const useIdlePrefetch = (preloadFns = [], { timeout = 2000 } = {}) => {
  useEffect(() => {
    const can = () => {
      const c = navigator.connection;
      if (!navigator.onLine) return false;
      if (c?.saveData) return false;
      if (['slow-2g', '2g'].includes(c?.effectiveType)) return false;
      return true;
    };

    if (!can() || preloadFns.length === 0) return;

    const idle = (cb) => {
      if ('requestIdleCallback' in window) {
        return window.requestIdleCallback(cb, { timeout });
      }
      return setTimeout(() => cb({ timeRemaining: () => 0, didTimeout: true }), 250);
    };

    const id = idle((deadline) => {
      if (deadline.timeRemaining() > 20 || deadline.didTimeout) {
        preloadFns.forEach((fn) => fn?.());
      }
    });

    return () => {
      if ('cancelIdleCallback' in window) window.cancelIdleCallback(id);
      else clearTimeout(id);
    };
  }, []);
}

export default useIdlePrefetch;